<template>
  <div>...</div>
</template>
<script>
import { redirect } from '@/utils/redirect.js'
import { getBusinessChannel } from '@/utils/mutiple.js'
export default {
  name: 'Redirect',
  async beforeRouteEnter(to, from, next) {
    let toQuery = { ...to.query }
    if (toQuery.hitoken) {
      await getBusinessChannel('hitoken')
    } else {
      delete toQuery.enter // 登录入口 login|register|bindphone...
      next({
        path: await redirect(to),
        query: toQuery,
      })
    }
    
  },
  created() {},
}
</script>
